/**
 * The dedicated endpoint requires a UUID in `Idempotency-Key`.
 * `crypto.randomUUID` is missing outside secure contexts, so the fallback
 * still produces a v4-shaped value rather than an ad-hoc string the backend
 * would have to accept on trust.
 */
export const createLeadTassoIdempotencyKey = () => {
  const uuid = globalThis.crypto?.randomUUID?.();
  if (uuid) return uuid;

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
  });
};
